import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks/useRedux";
import { BASE_URL } from "../Constants/BaseUrl";

const CoachItem = ({ color, item, sport_name }) => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.user);

  return (
    <button
      className="flex items-center px-5 py-2.5 border-b border-gray-700 relative w-full"
      onClick={() => {
        if (Number(item.user_id) !== Number(user?.user_id)) {
          if (item.role === "coach") {
            navigate("/coach-public-profile", {
              state: { user_id: item.user_id },
            });
          } else {
            navigate("/public-profile", {
              state: { user_id: item.user_id },
            });
          }
        } else {
          navigate("/profile", {});
        }
      }}
    >
      <img
        // src={
        //   item?.profile_picture
        //     ? `${BASE_URL}/${item.profile_picture}`
        //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        // }
        src={
          item?.profile_picture?.startsWith("https")
            ? item.profile_picture
            : item?.profile_picture
              ? `${BASE_URL}/${item.profile_picture}`
              : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        }
        alt="Avatar"
        className="w-16 h-16 rounded-full border-2 border-red-600 object-cover"
      />
      <div className="flex flex-col justify-start ml-5 text-left flex-1">
        <span className="text-lg font-semibold text-white">
          {item?.athlete_details?.first_name ?? ""}{" "}
          {item?.athlete_details?.last_name ?? ""}
        </span>
        <span className="text-sm text-white mt-1 max-w-full">
          Sport: {sport_name}
        </span>
      </div>
    </button>
  );
};

export default CoachItem;
